import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import swal from 'sweetalert2';
import LeaveTypeList from './pages/private/LeaveTypeList';
import API from '../middleware/API';
import {GetStoreRole} from '../const/constant';

class ReviewLeave extends Component {
  constructor(props) {
    super(props);
    this.state={
      leaveType: 0,
      selectDate: moment(),
      selectStartTime: moment(),
      selectEndTime: moment(),
      reason:'',
      attach:'',
      notes:'',
      name:'',
      byManual: true,
      beforeDay:0,
      minHours:0,
      wageTimes:0,
      leavesDay:0,
      deLeaveAmt:0,
      remainHolidayHours:-1,
      leaveRecId:0,
      staff:0,
      currentRole: GetStoreRole(localStorage.getItem('current_store_id'))
    }
    this.handleSelectStartTimeChange = this.handleSelectStartTimeChange.bind(this);
    this.handleSelectEndTimeChange = this.handleSelectEndTimeChange.bind(this);
    this.handleSaveWorkTime = this.handleSaveWorkTime.bind(this);
    this.handleLeaveTypeChange = this.handleLeaveTypeChange.bind(this);
    this.handleStaffTypeChange = this.handleStaffTypeChange.bind(this);
    this.handleSelectDateChange = this.handleSelectDateChange.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.handleReasonChange = this.handleReasonChange.bind(this);
    this.fileInput = React.createRef();
    this.emptyAllField = this.emptyAllField.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot){
    if(this.props.isVisible && this.props.editTarget.sDate && this.state.leaveRecId !== this.props.editTarget.id)
      API.get('/LeaveRec/RemainHolidayHour?input='+this.props.editTarget.sDate + '&userId='+this.props.editTarget.createdUserId).then((res)=>{
        this.setState({
          leaveRecId: this.props.editTarget.id,
          remainHolidayHours: res,
        })
      })
  }

  handleSelectStartTimeChange(moment) {    
    this.setState({
      selectStartTime: moment
    })
  }

  handleSelectEndTimeChange(moment) {    
    this.setState({
      selectEndTime: moment
    })
  }

  handleLeaveTypeChange(e) {  
    let leaveType = this.props.allLeaveType.find(leaveType => leaveType.id === parseInt(e.target.value))

    this.setState({
        leaveType: leaveType.id,
        notes: leaveType.notes,
        name: leaveType.name,
        beforeDay: leaveType.beforeDay,
        minHours: leaveType.minHours,
        wageTimes: leaveType.wageTimes,
        leavesDay: leaveType.leavesDay,
        deLeaveAmt: leaveType.deLeaveAmt,
    })
  }

  handleStaffTypeChange(e) {
    this.setState({
        staff: e.target.value
    })
  }

  handleReasonChange(e) {
    this.setState({
      reason: e.target.value
  })
  }
  diff = (start, end) => {
    start = start.split(":");
    end = end.split(":");
    let startDate = new Date(0, 0, 0, start[0], start[1], 0);
    let endDate = new Date(0, 0, 0, end[0], end[1], 0);
    let diff = endDate.getTime() - startDate.getTime();
    let hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    let minutes = Math.floor(diff / 1000 / 60);

    // If using time pickers with 24 hours format, add the below line get exact hours
    if (hours < 0)
       hours = hours + 24;

    // if (hours + (minutes/60) > 8 && this.state.leaveType === 1)
    //   swal({
    //     type: 'error',
    //     title: '特休一天最多只能請8小時',
    //     showConfirmButton: false,
    //     showCloseButton: true,
    //     heightAuto: false,
    //     width: '250px'
    //   });
    if(hours + (minutes/60) > 8){
      //this.props.onChangeFunc('leaveHours', 8);
      return 8;
    }
    if((hours + (minutes/60) )> 0)
      //this.props.onChangeFunc('leaveHours', (hours + (minutes/60)));
    return hours + (minutes/60);
  }

  handleSaveWorkTime(e) {
    e.preventDefault();
    const { toggleOpen, longLeave,editTarget } = this.props;
    const { selectDate, selectStartTime,  selectEndTime, staff, reason, leaveType,currentRole} = this.state;
    if (editTarget.leaveItemId === 0) {
      swal({
        type: 'error',
        title: '尚未選取假別',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    // } else if (moment(editTarget.eDate).diff(moment(editTarget.sDate)) / 1000 / 60 / 60 > 8 && editTarget.leaveItemId === 1) {
    //   swal({
    //     type: 'error',
    //     title: '特休一天最多只能請8小時',
    //     showConfirmButton: false,
    //     showCloseButton: true,
    //     heightAuto: false,
    //     width: '250px'
    //   });
    //   return;
    } else if (moment(editTarget.eDate).diff(moment(editTarget.sDate)) <= 0) {
      swal({
        type: 'error',
        title: '時間輸入有誤',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    } else if (currentRole !== '4' && editTarget.agentUserId === 0) {
      swal({
        type: 'error',
        title: '請選擇職務代理人',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    }

    this.emptyAllField();
    this.props.saveWorkRecordFunc(this.fileInput.current.files[0]);
    toggleOpen();
  }

  emptyAllField(){
    this.setState({
      leaveType: 0,
      selectDate: moment(),
      selectStartTime: moment(),
      selectEndTime: moment(),
      reason:'',
      attach:'',
      staff:0,
    })
  }
  
  handleSelectDateChange(moment) {
    this.setState({
      selectDate: moment
    })
  }
  handleCommentChange(e) {
    this.setState({
      notes: e.target.value
    })
  }
  handleDateChangeRaw = (e) => {
    e.preventDefault();
  }
  onValueChange(event) {
    var targerValue = (event.target.value === 'true');
    if(!targerValue){
      this.props.onChangeFunc('eDate', moment(this.props.editTarget.eDate).format('YYYY-MM-DDTHH:mm'));
    }
    this.setState({
      byManual: targerValue
    })
  }
  render() {
    let { isVisible, toggleOpen, targetDate, editTarget, onChangeFunc, targetEventId, longLeave } = this.props;
    let{currentRole, name,notes}  = this.state;
    if (!isVisible) {
      return null;
    }
    let isDisable = editTarget.leaveItemId === 1 ? editTarget.remainHours <= 0 : false;
    return (
    <div className="p-staff-list">
        <div className="u-editblock fadeIn" onClick={toggleOpen}>
              <div className="form-block" style={{minWidth:'400px', maxWidth:'80%'}} onClick={(e)=>{e.stopPropagation();}}>
    <div className="u-small-title">{longLeave?'請長假':'請假單'}</div>
                <form className="u-form">
                  <div className="row">
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>假別：{editTarget.leaveTypeName}</label>
                    </div>
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>日期：{moment(editTarget.applyDate).format('YYYY-MM-DD')}</label>

                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px' }}>事由：</label>
                      <textarea cols="35" rows="5" disabled style={{resize:'none', background:'white',color:'black',border:'none'}} value={editTarget.reasons ? editTarget.reasons : '未填寫'}></textarea>
                    </div>
                  </div>
                  <div className="row">
                    {
                      currentRole !== '4'?
                        <div className="col-6 col-pad-12">
                        <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>代理：{editTarget.agentUser ? editTarget.agentUser.realName : '無'}</label>
                        
                      </div>
                      :
                      ''
                    }
                  </div>
                  {
                    longLeave ? 
                      ''
                    :
                    <div className="row">
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>時段：{moment(editTarget.sDate).format('HH:mm')}</label>
                    </div>
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>至：{moment(editTarget.eDate).format('HH:mm')}</label>
                    </div> 
                  </div>
                  }

                  <div className="row">
                    <div className="col-12 col-pad-12">
                <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>時數：{editTarget.leaveHours}小時
                {/* <input type="number" style={{width:"80px"}} className="u-form__input" step="0.5" value={editTarget.leaveHours ? editTarget.leaveHours:0} onChange={(e)=>{this.props.onChangeFunc('leaveHours', e);}}/>小時                          */}
                    {
                      editTarget.leaveItemId === 1 ?`(剩餘特休時數:${editTarget.remainHours})`:editTarget.leaveItemId === 24 ?`(剩餘補休時數:${this.state.remainHolidayHours})`:editTarget.leaveItemId === 23 ?`(剩餘補休時數:${editTarget.compensatoryHours})`:''
                    }</label>   
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>備註：</label>
                      <input type="text" className="u-form__input" value={notes} onChange={e=>this.handleCommentChange(e)}/>
                    </div>
                    <div className="col-6 col-pad-12">
                      <div className="u-btn-group right">
                        <button className="btn btn-md success" type="button" onClick={() => {this.props.signingFunc(editTarget.id, '1',notes, editTarget.leaveHours);}}>核准</button>
                        <button className="btn btn-md delete" type="button" onClick={() => {this.props.signingFunc(editTarget.id, 'X',notes, editTarget.leaveHours);}}>作廢</button>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-pad-12">
                      <span style={{color:'red'}}>請確認時段小時數與請假時數是否一致，不一致請作廢。否則系統會以時數進行計算。</span>
                    </div>
                  </div>
                </form>
              </div>
            </div>
      </div>
    )
  }
}

export default ReviewLeave;